import React, { useMemo } from 'react';
import { Carousel } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useGetSlidersQuery } from '../../../redux/services/sliders';

const Slider = () => {
  const { data: sliders, isLoading } = useGetSlidersQuery();

  const orderedSliders = useMemo(() => {
    return (sliders || []).toSorted((a, b) =>
      a.position > b.position ? 1 : -1,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sliders]);

  return isLoading ? (
    <></>
  ) : (
    <Carousel
      autoplay
      arrows={true}
      nextArrow={<RightIcon />}
      prevArrow={<LeftIcon />}
    >
      {orderedSliders.map((item) => (
        <a key={item.id} href={item.target_url}>
          <img src={item.image} alt={item.meta_name} />
        </a>
      ))}
    </Carousel>
  );
};

export default Slider;

const RightIcon = ({ currentSlide, slideCount, ...props }) => (
  <RightOutlined {...props} />
);
const LeftIcon = ({ currentSlide, slideCount, ...props }) => (
  <LeftOutlined {...props} />
);
